module.exports = __webpack_public_path__ + "assets/15e1d6459186d5b7a620ca1a26548d08.mp3";